/** The steps of one section, shown the same way inside the portal and on the
 *  public link page. The wording is data — nothing here is written by hand. */
import React from 'react';
import { MapPin } from 'lucide-react';

const Numbered = ({ steps, testid }) => (
    <ol className="space-y-2.5" data-testid={testid}>
        {steps.map((step, i) => (
            <li key={i} className="flex gap-3">
                <span className="shrink-0 w-6 h-6 rounded-full bg-emerald-600 text-white text-xs font-bold grid place-items-center mt-0.5">
                    {i + 1}
                </span>
                <span className="text-base leading-relaxed">{step}</span>
            </li>
        ))}
    </ol>
);

export const ManualSteps = ({ section }) => (
    <div className="space-y-8">
        <div>
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">{section.title}</h1>
            <p className="mt-3 inline-flex items-start gap-2 text-sm text-slate-500"
               data-testid="manual-where">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
                <span><span className="font-semibold">Where to find it:</span> {section.where}</span>
            </p>
        </div>

        <section>
            <h2 className="text-base md:text-lg font-semibold mb-3">Turn it on / set it up</h2>
            <Numbered steps={section.steps} testid="manual-steps-on" />
        </section>

        <section>
            <h2 className="text-base md:text-lg font-semibold mb-3">Turn it off / undo</h2>
            <Numbered steps={section.off_steps} testid="manual-steps-off" />
        </section>

        {(section.extras || []).map((extra, i) => (
            <section key={i}>
                <h2 className="text-base md:text-lg font-semibold mb-3">{extra.title}</h2>
                <Numbered steps={extra.steps} testid={`manual-extra-${i}`} />
            </section>
        ))}
    </div>
);

export default ManualSteps;
